import axios from 'axios';
import { supabase } from './supabase';

const API_BASE = process.env.REACT_APP_API_URL || 'https://ivision-crm-backend-production.up.railway.app';

const axiosClient = axios.create({
  baseURL: API_BASE,
});

axiosClient.interceptors.request.use(async (config) => {
  let token = null;

  // Try Supabase session first
  try {
    const { data: { session } } = await supabase.auth.getSession();
    token = session?.access_token;
  } catch(e) {}

  // Fallback: read directly from localStorage if session not ready
  if (!token) {
    try {
      const key = Object.keys(localStorage).find(k => k.includes('auth-token'));
      if (key) {
        const stored = JSON.parse(localStorage.getItem(key));
        token = stored?.access_token;
      }
    } catch(e) {}
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Super admin tenant override
  try {
    var override = localStorage.getItem('sa_tenant_override');
    if (override) {
      config.headers['x-tenant-override'] = override;
    }
  } catch(e) {}
  return config;
}, (error) => Promise.reject(error));

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const { data: { session } } = await supabase.auth.refreshSession();
      if (session) {
        error.config.headers.Authorization = `Bearer ${session.access_token}`;
        return axiosClient(error.config);
      }
      await supabase.auth.signOut();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
